// extracted by mini-css-extract-plugin
export default {"EditeUserDiv":"EditeGroup_EditeUserDiv__YjjQT","title":"EditeGroup_title__dpmPb","InputsDiv":"EditeGroup_InputsDiv__QvKGe"};